import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

const sliders = document.querySelectorAll(".component-slider .swiper");
const defaultOptions = {
  modules: [Navigation, Autoplay],
  spaceBetween: 30,
  slidesPerView: 1,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: true,
  },
  loop: true,
  breakpoints: {
    250: {
      slidesPerView: 1,
    },
    720: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4,
    },
  },
};

[].forEach.call(sliders, function (slider, index, arr) {
  var data = slider.getAttribute("data-swiper");

  var dataOptions = {};
  if (data) {
    try {
      dataOptions = JSON.parse(data);
    } catch (e) {
      console.warn("Invalid JSON in data-swiper attribute:", data);
    }
  }

  slider.options = Object.assign({}, defaultOptions, dataOptions);

  new Swiper(slider, slider.options);
});
